import { ComponentDefineDic, ComponentElem } from "./interfaces";
import InternationalCall from "./ui/inputs/InternationalCall";
import RwdPicture from "./RwdPicture";
import CheckboxSmall from "./ui/checkboxs/CheckboxSmall";
import Select from "./ui/inputs/Select";
import SimpleInput from "./ui/inputs/SimpleInput";
import Input from "./ui/inputs/Input";
import LoginInput from "./ui/LoginInput";
import RadioSelect from "./ui/checkboxs/RadioSelect";
import CollapseWrapper from "./ui/CollapseWrapper";
import Coupon from "./fill-reserve/Coupon";
import CollapseButton from "./ui/buttons/CollapseButton";
import Field from "./ui/inputs/Field";
import VCodeInput from "./ui/inputs/VCodeInput";
import Searchbar from "./ui/inputs/Searchbar";
import Footer from "./popups/Footer";
import ActivityPromote from "./ui/blocks/ActivityPromote";
import MemberOptionsBlock from "./shared/MemberOptionsBlock";
import ContentWrapper from "./ui/ContentWrapper";
import Captcha from "./ui/inputs/Captcha";
import TextBubble from "./ui/TextBubble";

let _componentDic: ComponentDefineDic = {
  "activity-promote": {
    componentClass: ActivityPromote
  },
  "login-input": {
    componentClass: LoginInput,
  },
  "simple-input": {
    componentClass: SimpleInput,
  },
  "checkbox-small": {
    componentClass: CheckboxSmall,
  },
  "radio-select": {
    componentClass: RadioSelect,
  },
  "rwd-picture": {
    componentClass: RwdPicture,
  },
  "international-call": {
    componentClass: InternationalCall,
  },
  "select": {
    componentClass: Select,
  },
  "field": {
    componentClass: Field,
  },
  "vcode-input": {
    componentClass: VCodeInput,
  },
  "input": {
    componentClass: Input,
  },
  "captcha": {
    componentClass: Captcha
  },
  "searchbar": {
    componentClass: Searchbar
  },
  "collapse-wrapper": {
    componentClass: CollapseWrapper,
  },
  "content-wrapper": {
    componentClass: ContentWrapper,
  },
  "coupon": {
    componentClass: Coupon,
  },
  "collapse-button": {
    componentClass: CollapseButton,
  },
  "footer": {
    componentClass: Footer
  },
  "member-options-block": {
    componentClass: MemberOptionsBlock
  }
}

export default class Components {
  static init() {
    TextBubble.instance = new TextBubble();
    Components.bindScripts(null, true);
    Components.seekAndBind("collapse-wrapper");
  }

  static bindScripts(targetElem?: HTMLElement, catchSamples: boolean = false) {
    let $doms: JQuery = targetElem ? $(targetElem).find('[component]') : $('[component]');
    // 先抓取樣本
    if (catchSamples) {
      $.each($doms, (index: Number, elem: HTMLElement) => {
        let componentName: string = elem.getAttribute('component');
        if (_componentDic[componentName]) {
          let obj = _componentDic[componentName];
          let componentClass: any = obj.componentClass ? obj.componentClass : obj;
          if (elem.getAttribute("is-sample") === "true") {
            elem.removeAttribute("is-sample");
            $(elem).detach();
            if (!componentClass.$sample) {
              componentClass.$sample = $(elem).clone();
              let $doms = componentClass.$sample.find('[is-sample="true"]');
              $.each($doms, (index, childElem) => {
                childElem.removeAttribute("is-sample");
              });
            }
          }
        }
      });
    }

    // 再綁定程式
    $.each($doms, (index: Number, elem: HTMLElement) => {
      // true: 手動
      let manualBind: string = elem.getAttribute("manual-bind");
      ///@ts-ignore
      if (elem._component) {
      } else if (manualBind !== "true") {
        let componentName: string = elem.getAttribute('component');
        if (_componentDic[componentName]) {
          let obj = _componentDic[componentName];
          this.bindScripts(elem); // 先掃描內部元素
          let componentClass: any = obj.componentClass ? obj.componentClass : obj;
          new componentClass(elem);
        }
      }
    });
  }

  static seekAndBind(componentName: string) {
    let elemList = $(`[component="${componentName}"]`).toArray(),
      obj = _componentDic[componentName];
    if (obj) {
      elemList.forEach((elem: ComponentElem, index) => {
        let componentClass: any = obj.componentClass ? obj.componentClass : obj;
        new componentClass(elem);
      });
    }
  }

  static registComponents(dic: ComponentDefineDic) {
    _componentDic = Object.assign({}, dic, _componentDic);
  }
}